import { createFileRoute, redirect } from "@tanstack/react-router";
import { fetchMe } from "@/lib/auth";
import { queryClient } from "@/lib/query-client";

// Root "/" redirect: dispatch to /admin, /app, or /login based on auth.
// Pulls from the shared react-query cache so we don't double-fetch when the
// parent __root beforeLoad just resolved the same call.
export const Route = createFileRoute("/")({
  beforeLoad: async () => {
    const auth = await queryClient.ensureQueryData({
      queryKey: ["auth", "me"],
      queryFn: fetchMe,
      staleTime: 5 * 60 * 1000,
    });
    if (!auth) {
      throw redirect({ to: "/login" });
    }
    if (auth.kind === "staff") {
      throw redirect({ to: "/admin" });
    }
    // client_user and agency_user both live in /app/*.
    throw redirect({ to: "/app" });
  },
  // This component will never render because beforeLoad always redirects.
  component: () => null,
});
